"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentButton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var react_i18next_1 = require("react-i18next");
require("./style.scss");
var react_spinners_1 = require("react-spinners");
var PaymentButton = function (_a) {
    var _b;
    var isDisabled = _a.isDisabled, _c = _a.pay, pay = _c === void 0 ? function () { } : _c, total = _a.total, currency = _a.currency;
    var t = (0, react_i18next_1.useTranslation)().t;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "checkout-total-button" }, { children: (0, jsx_runtime_1.jsxs)("button", __assign({ type: "submit", className: (0, classnames_1.default)('basket-total-button checkout-total-button', (_b = {}, _b['checkout-total-button-disabled'] = isDisabled, _b)), onClick: pay }, { children: [(0, jsx_runtime_1.jsxs)("span", __assign({ className: "checkout-total-button-pay-now" }, { children: [t('Pay now'), " ", isDisabled && (0, jsx_runtime_1.jsx)(react_spinners_1.PulseLoader, { color: "rgb(127, 86, 217)", size: 6 })] })), (0, jsx_runtime_1.jsxs)("span", __assign({ className: "basket-total-header-price" }, { children: [currency === null || currency === void 0 ? void 0 : currency.title, total.toFixed(2)] }))] })) })));
};
exports.PaymentButton = PaymentButton;
